var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed_background_layer",style:({
    backgroundColor: _vm.f_b.radio_val !== 'hidden' ? _vm.f_b[_vm.f_b.radio_val].color : '',
    backgroundImage:_vm.f_b.radio_val !== 'hidden' && _vm.f_b[_vm.f_b.radio_val].img !== '' ? 'url('+_vm.f_b[_vm.f_b.radio_val].img+')' : 'none',
    backgroundSize: _vm.f_b.radio_val !== 'hidden' ? _vm.f_b[_vm.f_b.radio_val].background_size : 'auto',
    backgroundRepeat: _vm.f_b.radio_val !== 'hidden' ? _vm.f_b[_vm.f_b.radio_val].background_repeat : 'repeat',
    backgroundPosition: _vm.f_b.radio_val !== 'hidden' ? _vm.f_b[_vm.f_b.radio_val].background_position : '0% 0%',
  })})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77ccc6ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fixed_background_layer/index.vue
// module id = null
// module chunks = 